<template>
  <div class="text-black p-4 bg-[#ECF1F5] rounded-md">
    <slot />
  </div>
</template>
